import { ccApi } from './ccApi';
import { CC_API_TAGS } from './constants';
const RULE_FOLDERS_PATH = 'rule/folders';
const invalidateFolderTags = (id) => [
    CC_API_TAGS.RuleFolderList,
    { type: CC_API_TAGS.RuleFolder, id },
];
export const ruleFolderApi = ccApi.injectEndpoints({
    endpoints: (builder) => ({
        getRuleFolders: builder.query({
            query: ({ areaId }) => `/${areaId}/${RULE_FOLDERS_PATH}`,
            providesTags: [CC_API_TAGS.RuleFolderList],
        }),
        createRuleFolder: builder.mutation({
            query: ({ areaId, name, ruleIds = [] }) => ({
                url: `/${areaId}/${RULE_FOLDERS_PATH}`,
                method: 'POST',
                body: { name, ruleIds },
            }),
            invalidatesTags: [CC_API_TAGS.RuleFolderList],
        }),
        addRuleIdsToRuleFolder: builder.mutation({
            query: ({ areaId, id, ruleIds }) => ({
                url: `/${areaId}/${RULE_FOLDERS_PATH}/${id}/rules/add`,
                method: 'POST',
                body: { ruleIds },
            }),
            invalidatesTags: (_result, _error, { id }) => invalidateFolderTags(id),
        }),
        removeRuleIdsFromRuleFolder: builder.mutation({
            query: ({ areaId, id, ruleIds }) => ({
                url: `/${areaId}/${RULE_FOLDERS_PATH}/${id}/rules/remove`,
                method: 'POST',
                body: { ruleIds },
            }),
            invalidatesTags: (_result, _error, { id }) => invalidateFolderTags(id),
        }),
        deleteRuleFolder: builder.mutation({
            query: ({ areaId, id }) => ({
                url: `/${areaId}/${RULE_FOLDERS_PATH}/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (_result, _error, { id }) => invalidateFolderTags(id),
        }),
    }),
});
export const { useGetRuleFoldersQuery, useLazyGetRuleFoldersQuery, useCreateRuleFolderMutation, useAddRuleIdsToRuleFolderMutation, useRemoveRuleIdsFromRuleFolderMutation, useDeleteRuleFolderMutation, } = ruleFolderApi;
